import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, Tab as MuiTab } from "@mui/material";
import clsx from "clsx";
import { TabProps } from "react-admin";

/**
 * Alternative to the react-admin <Tab> component,
 * which does not wrap the tab content in a <Labeled> component.
 */
export function Tab2(props: TabProps & { oldValue?: number | string; badge?: ReactNode }) {
  const {
    children,
    contentClassName, // oxlint-disable-line no-unused-vars
    context,
    count,
    className,
    divider, // oxlint-disable-line no-unused-vars
    icon,
    label,
    record, // oxlint-disable-line no-unused-vars
    syncWithLocation = true,
    value,
    oldValue: _,
    badge,
    ...rest
  } = props;
  const location = useLocation();
  const propsForLink = {
    component: Link,
    to: { ...location, pathname: value },
  };

  const renderHeader = () => {
    let tabLabel = label;
    if (count !== undefined) {
      tabLabel = (
        <span>
          {tabLabel} ({count})
        </span>
      );
    }

    return (
      <MuiTab
        key={`tab-header-${value}`}
        label={
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            {tabLabel}
            {badge}
          </Box>
        }
        value={value}
        icon={icon}
        className={clsx("show-tab", className)}
        {...(syncWithLocation ? propsForLink : {})} // to avoid TypeScript screams, see https://github.com/mui/material-ui/issues/9106#issuecomment-451270521
        {...rest}
      />
    );
  };

  return context === "header" ? renderHeader() : children;
}
